import { Text } from '../../atoms'
import { TextTypes } from '../../../types'
import { TranslatedText } from '../../../types/TranslatedText'
import React, { ReactElement } from 'react'

export interface FieldsetProps extends Omit<React.HTMLAttributes<HTMLFieldSetElement>, 'title'> {
    title: TranslatedText
}

export const Fieldset = ({ title, children, ...props }: FieldsetProps): ReactElement => {
    return (
        <fieldset {...props} className={`bg-shade-opacity-100 p-4 focus-within:z-10 ${props.className ?? ''}`}>
            <Text type={TextTypes.HEADING_4} className="text-text-primary">
                {title}
            </Text>
            <div className="mt-4 flex flex-wrap gap-6 flex-col">{children}</div>
        </fieldset>
    )
}
